/**
 * Composable for athlete data aggregation and manipulation
 * Converted from mixins/helpers.js to Composition API
 */
import _ from 'lodash';

/**
 * Aggregate activities by athlete into totals
 * @param {Array} activities - Array of activity objects
 * @returns {Array} Array of athlete totals with distance, elevation, time
 */
export function athleteTotals(activities) {
  return _(activities)
    .groupBy('athlete')
    .map((athlete) => ({
      athlete: (athlete[0].user) ? athlete[0].user.username : athlete[0].athlete,
      distance: _.sumBy(athlete, item => Number(item.distance)),
      elevation: _.sumBy(athlete, item => Number(item.elevation_gain)),
      time: _.sumBy(athlete, item => Number(item.moving_time)),
    }))
    .value();
}

/**
 * Sort an array by a property in descending order
 * @param {Array} arr - Array to sort
 * @param {string} property - Property name to sort by
 * @returns {Array} Sorted array (descending)
 */
export function sortByDesc(arr, property) {
  return _(arr)
    .sortBy(property)
    .reverse()
    .value();
}

/**
 * Group an array by a property
 * @param {Array} arr - Array to group
 * @param {string} property - Property name to group by
 * @returns {Object} Grouped object
 */
export function groupByProperty(arr, property) {
  return _(arr)
    .groupBy(property)
    .value();
}

/**
 * Apply override distance to activities if present
 * @param {Array} activities - Array of activity objects
 * @returns {Array} Activities with override distances applied
 */
export function applyOverrideDistances(activities) {
  for (const activity of activities) {
    if (activity.override_distance) {
      activity.distance = activity.override_distance;
    }
  }
  return activities;
}

/**
 * Composable hook that returns all athlete data functions
 * @returns {Object} Object containing all athlete data functions
 */
export function useAthleteData() {
  return {
    athleteTotals,
    sortByDesc,
    groupByProperty,
    applyOverrideDistances,
  };
}

export default useAthleteData;
